import { CaptureEnvironment, getCaptureConfig, PROPOSAL_TARGETS } from "@/lib/proposalPartialCapture";
import { startProposalCapture } from "@/lib/proposalPartialCaptureController";

/** One site-wide listener set per page, installed before any React form embeds. */
export function createSiteProposalCapture(runtimeEnvironment: string | undefined, endpoint: string | undefined) {
  let activePage: string | undefined;
  let cleanups: Array<() => void> = [];
  const environments = Object.keys(PROPOSAL_TARGETS) as CaptureEnvironment[];
  const stop = () => {
    cleanups.forEach(cleanup => cleanup());
    cleanups = [];
    activePage = undefined;
    environments.forEach(environment => document.documentElement.removeAttribute(`data-proposal-capture-${environment}`));
  };
  const navigate = (pageUrl: string) => {
    // Build configuration controls the kill switch, never the destination tab.
    if (runtimeEnvironment !== "staging" && runtimeEnvironment !== "production") return;
    const configs = environments.flatMap(environment => {
      const config = getCaptureConfig(environment, endpoint, pageUrl);
      return config ? [config] : [];
    });
    if (configs.length && configs[0].pageUrl === activePage) return;
    stop();
    activePage = configs[0]?.pageUrl;
    cleanups = configs.map(config => startProposalCapture(config, state => {
      // Operational state only; no field values or analytics events.
      document.documentElement.setAttribute(`data-proposal-capture-${config.environment}`, state);
    }));
  };
  return { navigate, stop };
}
